import { render, staticRenderFns } from "./PageSectionContent.vue?vue&type=template&id=e6b5507a"
import script from "./PageSectionContent.vue?vue&type=script&lang=js"
export * from "./PageSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports